import { createAction } from 'redux-act';
import { PaneIndex } from '@helpers/horizontalPaneState';

export const setLastInfoPane = createAction<PaneIndex>('Set last info pane');
export const setLastNotesPane = createAction<PaneIndex>('Set last notes pane');



// WEBPACK FOOTER //
// ./src/services/ui/ui.actions.ts